var SV = require('server-vars');
var cookies = require('browser-cookies');

var constants = {
    COOKIE_USER: 'userToken',
    COOKIE_USER_MASQUERADE: 'masqueradeBuyer'
};

function getAdminUserData() {
    return SV.get('userData');
};

function getSellerData() {
    return SV.get('sellerData');
};

/**
 * Returns either a sellerToken or userToken depending on who is currently logged in.
 * @returns {String} The token for the currently logged in user.
 */
function getToken() {
    var token;
    var tokenObj = {};
    var userData = getAdminUserData();
    var sellerData = getSellerData();
    var cookieToken = cookies.get(constants.COOKIE_USER);

    if (typeof window === 'undefined') {
        return {};
    }

    //Set user token for masquerade
    if (sellerData && userData) {
        token = cookieToken ? cookieToken : userData.token;
        tokenObj.userToken = token;
    //Be extra sure we only send the sellerToken when we're on an Admin page
    } else if (sellerData) {
        token = sellerData.token;
        tokenObj.sellerToken = token;
    } else if (cookieToken) {
        token = cookieToken;
        tokenObj.userToken = token;
    }
    return token ? tokenObj : null;
};

/**
 * @param {Boolean} [getRealUser] - skip masquerading
 * @returns {String}
 */
function getUserId(getRealUser) {
    // jank work-around for GOODS-2407
    // todo User model needs to be made Universal (isomorphic)
    if (typeof document === 'undefined') {
        return null;
    }

    var userMasqueradeCookie = cookies.get(constants.COOKIE_USER_MASQUERADE); // eslint-disable-line vars-on-top
    var userCookie = cookies.get(constants.COOKIE_USER); // eslint-disable-line vars-on-top

    if (userMasqueradeCookie && !getRealUser) {
        return userMasqueradeCookie.slice(2);
    } else {
        return userCookie ? userCookie.substr(0, userCookie.indexOf('_')) : null;
    }
};

module.exports = {
    getToken: getToken,
    getUserId: getUserId,
    constants: constants
};
